import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";

export const getFile = (id: number): AxiosPromise<Blob> => {
  return axiosInstance.get(`/file/${id}`, {
    responseType: "blob",
  });
};
